import React, { forwardRef, useState, useEffect, memo, useRef } from 'react'
import { useI18n } from '@/hooks/useLocale'
import { useMountedState } from '@/hooks/useMountedState'
import { Button, Dropdown, Menu, Table } from '@arco-design/web-react'
import { GetAdapterColumns } from './columnAdapter'
import {
  IconDelete,
  IconDown,
  IconEdit,
  IconZoomIn,
} from '@arco-design/web-react/icon'
import { getSettings } from '@/store/slices/appSlice'
import getUrlParams from '@/utils/getUrlParams'
import { useSelector } from 'react-redux'

const shareValue = { stopTriggerChange: false }
function _LoongInCommonTable(
  {
    children, //never
    className,
    style,
    isLoading, //正在加载
    columns, //列定义(width，align，title，key) align:left 左对齐、right 右对齐和 center 居中对齐
    data, //数据
    zebra = true, //斑马纹
    size, // = 'small', //'mini' | 'small' | 'default' | 'large'
    customRowHeight, //当sizeClass==“custom"时有效
    scrollableBody = true, //是否滚动
    height, //高度
    width, //宽度
    keyField = 'id', //主键，默认id
    canShow, //是否可以查看
    onShow, //点击查看时
    canEdit, //是否可编辑
    onEdit, //点击编辑时
    canDelete, //是否可删除
    onDelete, //点击删除时
    showPage = true, //是否显示分页
    onGotoPage, //跳转分页时
    rowCount = 0, //行数
    currentPage, //当前页码
    currentPageSize = 10, //当前页行数
    onSetPageSize, //每页行数变化时触发的(size,newPage)
    otherMenu, //其他菜单
    enableSorting, //开启排序功能
    onSort, //排序事件
    actionRender, //自定义操作列
    canSelection, //是否开启选择功能
    onSelectionChange, //选择改变时触发
    multipleChoice, //是否开启多选，默认是多选
    checkCanDelete, //检查当前行是否可删除
    checkCanEdit, //检查当前行是否可编辑
    checkCanShow, //检查当前行是否可查看
    onClick, //单击事件，传入参数(item,index,event)
    onDoubleClick, //双击事件，传入参数(item,index,event)
    onContextMenu, //右键事件，传入参数(item,index,event)
    highlightRow, //是否将当前行高亮
    renderSumary, //合计项
    operationCol, //{title:"",fixed:"right",width:120}
    selectedRowKeys, //
    onHeadHeightChange, //
    onExpand,
    needNum, //是否需要序号
    expandedRowKeys,
    checkboxProps, //是否禁用事件
    onOperateButtonCount, //传递按钮数量
    sizeOptions = [10, 20, 50, 100, 500],
    showOperationCol = true, //是否开启操作列，默认开启
    maxHeight,
    rowClassName, //表格行的类名
    selectionColumnWidth, //选择列宽度
    paginationSimple = false, //简洁分页
    paginationSizeCanChange = true, //分页大小是否可变
    useRowCheckClick,
    disabled,
    canEditText,
    canShowText,
    deleteText, //删除文本
    locale=[], //locale
    ...rest //needNumWidth:序号列宽度
  },
  ref
) {
  const _TableHeadHeightRef = useRef(null)
  const t = useI18n(locale)
  const isMounted = useMountedState()
  const [sortState, setSortState] = useState({ key: '', sortUp: true })
  const [selectedKeys, setSelectedKeys] = useState(selectedRowKeys ?? [])
  const urlParams = getUrlParams()
  const settings = useSelector(getSettings)
  const tableSize = size || urlParams.tableSize || settings.tableSize
  const [tableHeadHeight, setTableHeadHeight] = useState(undefined)
  const [currentRow, setCurrentRow] = useState(null)
  const [operateButtonsCount, setOperateButtonsCount] = useState(0)
  useEffect(() => {
    if (!isMounted()) return
    setSelectedKeys(selectedRowKeys)
  }, [selectedRowKeys])
  //添加操作按钮

  const otherCols = []
  useEffect(() => {
    if (tableHeadHeight !== undefined) {
      onHeadHeightChange && onHeadHeightChange(tableHeadHeight)
    }
  }, [tableHeadHeight])
  const caculateOperateButtonCount = () => {
    let rst = 0
    if (operationCol?.render) return rst
    if (canShow) {
      rst++
    }
    if (canEdit) {
      rst++
    }
    if (canDelete) {
      rst++
    }
    return rst
  }
  useEffect(() => {
    const count = caculateOperateButtonCount()
    setOperateButtonsCount(count)
    onOperateButtonCount && onOperateButtonCount(count)
  }, [])
  if (
    showOperationCol &&
    (operationCol?.render || canShow || canEdit || canDelete || otherMenu)
  ) {
    otherCols.push({
      title: operationCol?.title ?? t('t_operate'),
      dataIndex: 'operations',
      align: 'center',
      render: (_, item, index) => {
        if (operationCol?.render) return operationCol.render(item, index)
        const rst = []
        if (
          !item._hideOperate &&
          canShow &&
          (!checkCanShow || checkCanShow(item, index))
        ) {
          rst.push(
            <Button
              key={1}
              type="text"
              icon={<IconZoomIn />}
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                onShow && onShow(item, index)
              }}
            >
              {canShowText ?? t('b_show')}
            </Button>
          )
        }
        if (
          !item._hideOperate &&
          canEdit &&
          (!checkCanEdit || checkCanEdit(item, index))
        ) {
          rst.push(
            <Button
              key={2}
              type="text"
              icon={<IconEdit />}
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                onEdit && onEdit(item, index)
              }}
            >
              {canEditText ?? t('b_edit')}
            </Button>
          )
        }
        if (
          !item._hideOperate &&
          canDelete &&
          (!checkCanDelete || checkCanDelete(item, index))
        ) {
          rst.push(
            <Button
              key={3}
              type="text"
              status="danger"
              icon={<IconDelete />}
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                onDelete && onDelete(item, index)
              }}
            >
              {deleteText ?? t('b_del')}
            </Button>
          )
        }
        if (otherMenu) {
          const othButtons = otherMenu(item, index).map((m, idx) => {
            if (m.otherComponentsType == 'dropdown') {
              return (
                <Dropdown.Button
                  key={4 + idx + 10000}
                  icon={<IconDown />}
                  {...m}
                  droplist={m.dropList ?? <></>}
                >
                  {m.title}
                </Dropdown.Button>
              )
            } else {
              return (
                <Button
                  key={4 + idx}
                  type="text"
                  size="small"
                  {...m}
                  onClick={() => {
                    if (m.onClick) return m.onClick()
                    onEdit && onEdit(item, index)
                  }}
                >
                  {m.title}
                </Button>
              )
            }
          })
          rst.push(...othButtons)
        }
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {rst}
          </div>
        )
      },
      fixed: operationCol?.fixed ?? 'right',
      width: operationCol?.width ?? operateButtonsCount * 62 + 32 + 'px',
    })
  }
  const tabCols = GetAdapterColumns(
    columns,
    otherCols,
    enableSorting,
    needNum,
    rest?.needNumWidth,
    t,
    disabled
  )
  const onRowCheckClick_ = (item, index, event) => {
    let classNames = [
      'arco-icon-hover arco-checkbox-icon-hover arco-icon-hover-disabled arco-checkbox-mask-wrapper',
      'arco-checkbox-mask',
      'arco-icon-hover arco-checkbox-icon-hover',
      'arco-icon-hover arco-checkbox-icon-hover arco-checkbox-mask-wrapper',
    ]
    if (
      classNames.includes(event.target.className) ||
      event?.target.parentNode?.className?.baseVal ==
        'arco-checkbox-mask-icon' ||
      event.target.className?.baseVal == 'arco-checkbox-mask-icon'
    ) {
      return
    }
    if (multipleChoice) {
      let selectedRowKeys = selectedKeys ?? []
      let newSelectedRowKeys = selectedRowKeys?.includes(item[keyField])
        ? selectedRowKeys?.filter((x) => x !== item[keyField])
        : [...selectedRowKeys, item[keyField]]
      let tableData = [...data]
      let newtCheckItems = tableData?.filter((item) =>
        newSelectedRowKeys?.includes(item[keyField])
      )
      onSelectionChange([...newtCheckItems])
      setSelectedKeys(newSelectedRowKeys)
    } else {
      onSelectionChange([item])
      setSelectedKeys([item[keyField]])
    }
  }
  useEffect(() => {
    if (_TableHeadHeightRef.current) {
      const rootDom = _TableHeadHeightRef.current.getRootDomElement()
      let headHeight = 0
      if (rootDom) {
        const headerDom = rootDom.querySelector('.arco-table-header')
        if (headerDom) {
          headHeight = headerDom.clientHeight
          setTableHeadHeight(headHeight)
        }
      }
    }
  }, [_TableHeadHeightRef])
  return (
    <Table
      ref={_TableHeadHeightRef}
      className={className}
      style={{
        ...style,
        '--table-body-height': height + 'px',
      }}
      rowKey={keyField}
      showSorterTooltip={false}
      columns={tabCols}
      data={data}
      loading={isLoading}
      tableLayoutFixed={true}
      onChange={(pagination, sorter, filters, extra) => {
        switch (extra.action) {
          case 'paginate':
            onGotoPage && onGotoPage(pagination.current, pagination.pageSize)
            break
          case 'sort':
            if (!enableSorting) return
            onSort({
              key: sorter['field'],
              sortUp: sorter['direction'] == 'ascend',
            })
            break
          case 'filter':
            break
          default:
            break
        }
      }}
      pagination={
        showPage && {
          sizeCanChange: paginationSizeCanChange,
          sizeOptions: sizeOptions,
          total: rowCount,
          current: currentPage,
          pageSize: currentPageSize,
          simple: paginationSimple,
          showTotal: true,
          hideOnSinglePage: !showPage,
          size: tableSize,
        }
      }
      rowSelection={
        canSelection
          ? {
              fixed: true,
              columnWidth: selectionColumnWidth ?? 40,
              selectedRowKeys: selectedKeys,
              type: multipleChoice ? 'checkbox' : 'radio', //多选 //'radio' 单选
              onChange: (_selectedRowKeys, selectedRows) => {
                setSelectedKeys(_selectedRowKeys)
                onSelectionChange(selectedRows)
              },
              checkboxProps: (record) => {
                if (checkboxProps) {
                  return checkboxProps(record)
                }
                return {
                  disabled: false,
                }
              },
            }
          : undefined
      }
      onRow={(item, index) => {
        return {
          onClick: async (event) => {
            setCurrentRow(item)
            if (onClick && useRowCheckClick) {
              let flag = await onClick({
                item,
                index,
                event,
                tableSelectedKeys: selectedKeys,
                tableData: data,
              })
              if (flag) {
                onRowCheckClick_(item, index, event)
              }
            } else {
              onClick && onClick(item, index, event)
              useRowCheckClick && onRowCheckClick_(item, index, event)
            }
          }, // 点击表身行
          onDoubleClick: (event) => {
            onDoubleClick && onDoubleClick(item, index, event)
          },
          onContextMenu: (event) => {
            onContextMenu && onContextMenu(item, index, event)
          },
        }
      }}
      summary={renderSumary}
      stripe={zebra}
      size={tableSize}
      border={{ wrapper: false, headerCell: true, bodyCell: true, cell: true }}
      scroll={scrollableBody ? { x: width, y: height } : undefined}
      onExpandedRowsChange={onExpand}
      expandedRowKeys={expandedRowKeys}
      rowClassName={
        rowClassName
          ? rowClassName
          : highlightRow
          ? (record, index) => {
              if (currentRow && record[keyField] == currentRow[keyField]) {
                return 'currentRow'
              }
            }
          : undefined
      }
      {...rest}
    />
  )
}

const __LoongInCommonTable = forwardRef(_LoongInCommonTable)
export const LoongInCommonTable = memo(__LoongInCommonTable)

